import { render, staticRenderFns } from "./ShareRewardByMail.vue?vue&type=template&id=baab0e74&scoped=true&"
import script from "./ShareRewardByMail.vue?vue&type=script&lang=ts&"
export * from "./ShareRewardByMail.vue?vue&type=script&lang=ts&"
import style0 from "./ShareRewardByMail.vue?vue&type=style&index=0&id=baab0e74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baab0e74",
  null
  
)

export default component.exports